import {
  IAsphaltDesignImperial,
  AsphaltDesignMetric,
} from '@/modules/design/interfaces/newAsphalt';
import { UnitSystem } from '@/interfaces/units';
import {
  CM_TO_INCHES,
  INCHES_TO_CM,
  MPA_TO_PSI,
  PSI_TO_MPA,
  roundAfterUnitConversion,
} from '@/lib/unitConversion/unitConversionFactors';


export const newAsphaltDesignImperialToMetric = function (A: IAsphaltDesignImperial): AsphaltDesignMetric {
  // console.log('Converting Asphalt Imperial To Metric');

  const B = JSON.parse(JSON.stringify(A)); // Force deep copy
  B.displayUnits = UnitSystem.Metric;
  B.backingUnits = UnitSystem.Metric;
  B.unitSystem = UnitSystem.Metric;

  B.minimumThickness = A.minimumThickness ? roundAfterUnitConversion(A.minimumThickness * INCHES_TO_CM) : A.minimumThickness;
  B.substructureLayers = A.substructureLayers.map((L) => {
    const mL = JSON.parse(JSON.stringify(L));
    mL.thickness = L.thickness * INCHES_TO_CM;
    mL.modulus = L.modulus * PSI_TO_MPA; // PSI -> MPa
    return mL;
  });
  B.surfaceLayers = A.surfaceLayers.map((L) => {
    const mL = JSON.parse(JSON.stringify(L));
    mL.thickness = L.thickness ? roundAfterUnitConversion(L.thickness * INCHES_TO_CM) : L.thickness; // In -> cm
    mL.modulus = L.modulus * PSI_TO_MPA; // PSI -> MPa
    return mL;
  });
  B.subgrade = A.subgrade ? Number((A.subgrade * PSI_TO_MPA).toFixed(2)) : A.subgrade;

  return B;
};

export const asphaltMetricToImperial = function (A: AsphaltDesignMetric): IAsphaltDesignImperial {
  // console.log('Converting Asphalt Metric To Imperial');

  const B = JSON.parse(JSON.stringify(A)); // Force deep copy
  B.displayUnits = UnitSystem.Imperial;
  B.backingUnits = UnitSystem.Imperial;
  B.unitSystem = UnitSystem.Imperial;

  B.minimumThickness = A.minimumThickness ? roundAfterUnitConversion(A.minimumThickness * CM_TO_INCHES) : A.minimumThickness;
  B.substructureLayers = A.substructureLayers.map((L) => {
    const mL = JSON.parse(JSON.stringify(L));
    mL.thickness = L.thickness * CM_TO_INCHES;
    mL.modulus = L.modulus * MPA_TO_PSI;
    return mL;
  });
  B.surfaceLayers = A.surfaceLayers.map((L) => {
    const mL = JSON.parse(JSON.stringify(L));
    mL.thickness = L.thickness ? roundAfterUnitConversion(L.thickness * CM_TO_INCHES) : L.thickness; // In -> cm
    mL.modulus = L.modulus * MPA_TO_PSI; // PSI -> MPa
    return mL;
  });
  B.subgrade = A.subgrade ? roundAfterUnitConversion(A.subgrade * MPA_TO_PSI) : A.subgrade;

  return B;
};
